<template>
  <div :class="['countdown', { 'countdown-red': remainingTime <= 60 }]">
    {{ formattedTime }}
  </div>
</template>

<script>
export default {
  props: {
    initialTime: {
      type: Number, // in seconds
      required: true,
    },
  },
  data() {
    return {
      remainingTime: this.initialTime,
      intervalId: null,
    }
  },
  computed: {
    formattedTime() {
      const hrs = String(Math.floor(this.remainingTime / 3600)).padStart(2, '0')
      const mins = String(Math.floor((this.remainingTime % 3600) / 60)).padStart(2, '0')
      const secs = String(this.remainingTime % 60).padStart(2, '0')
      return `${hrs}:${mins}:${secs}`
    },
  },
  watch: {
    initialTime(newVal) {
      this.resetCountdown(newVal)
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    startCountdown() {
      if (this.intervalId) clearInterval(this.intervalId)
      this.intervalId = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime -= 1
        } else {
          clearInterval(this.intervalId)
          this.$emit('ended')
        }
      }, 1000)
    },
    resetCountdown(newTime) {
      clearInterval(this.intervalId)
      this.remainingTime = newTime
      this.startCountdown()
    },
  },
}
</script>

<style scoped>
.countdown {
  font-size: 1rem;
  font-weight: 500;
}
.countdown-red {
  color: red;
}
</style>
